const linkConfigurationPropsConversion = (props) => ({
    children: props?.children,
    dataTestId: props?.testId,
    disabled: props?.disabled,
    icon: props?.iconConfiguration,
    iconPosition: props?.iconPosition,
    onClick: props?.onClick,
    url: props?.href ?? '',
    variant: props.type,
    decoration: props?.decoration,
    target: props?.target,
    textVariant: props?.textVariant,
    action: props?.action,
});
export { linkConfigurationPropsConversion };
//# sourceMappingURL=link.configuration.js.map